import tradingModalStore from 'global/TradingModal/store';
import tradingDataStore from 'lib/stores/tradingData';
import useIsUserSyariah from 'global/TradingModal/hooks/useIsUserSyariah';

export interface SyariahReturnType {
  showSyariahRestrictionModal: () => void;
  hideSyariahRestrictionModal: () => void;
  checkSyariahTradeableStatus: (symbol: string) => Promise<boolean>;
  isUserSyariah: boolean;
}

const useSyariah = (): SyariahReturnType => {
  const setModalState = tradingModalStore((s) => s.setModalState);
  const checkStockTradable = tradingDataStore((s) => s.checkStockTradable);
  const isUserSyariah = useIsUserSyariah();

  const checkSyariahTradeableStatus = async (
    symbol: string,
  ): Promise<boolean> => {
    try {
      const { data } = await checkStockTradable(symbol);
      return data?.is_sharia_tradable;
    } catch (e) {
      return true;
    }
  };

  const showSyariahRestrictionModal = () => {
    setModalState({
      visible: true,
      modalData: {
        showShariaRestrictionBuy: true,
      },
    });
  };

  const hideSyariahRestrictionModal = () => {
    setModalState({
      modalData: {
        showShariaRestrictionBuy: false,
      },
    });
  };

  return {
    showSyariahRestrictionModal,
    hideSyariahRestrictionModal,
    checkSyariahTradeableStatus,
    isUserSyariah,
  };
};

export default useSyariah;
